import React from 'react';
import useLanguage from '../../../hooks/useLanguage';
import { Pagination } from '../../../components/Pagination';

const TableContainer = ({
    handlePagination = () => { },
    data = [],
    totalCount = 0,
    title = "",
    controller = {},
    children
}) => {
    const { t } = useLanguage();
    return (
        < >
            <div className='px-2'>
                <div>
                    <h1 className='font-18 fw-500 black-color mt-3'>{title}</h1>
                </div>
                <div className="col-12 d-flex ">
                    <div className="col-12 ">
                        <div className="table-responsive custom_table px-2 flex-fill mt-1">
                            {children}
                            {!data?.length && <div className="text-center mt-2 w-100 black-color">{t("tableTitle.noRecordFound")}</div>}
                        </div>
                        {
                            totalCount > 10 && <div >
                                <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default TableContainer;

